
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CannedResponse } from '@/types/cannedResponse';

export type CannedResponsesState = {
  responses: CannedResponse[];
  selectedResponse: CannedResponse | null;
  loading: boolean;
  error: string | null;
};

const initialState: CannedResponsesState = {
  responses: [],
  selectedResponse: null,
  loading: false,
  error: null,
};

const cannedResponsesSlice = createSlice({
  name: 'cannedResponses',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    setResponses: (state, action: PayloadAction<CannedResponse[]>) => {
      state.responses = action.payload;
    },
    addResponse: (state, action: PayloadAction<CannedResponse>) => {
      state.responses.push(action.payload);
    },
    updateResponse: (state, action: PayloadAction<CannedResponse>) => {
      const index = state.responses.findIndex(response => response.id === action.payload.id);
      if (index !== -1) {
        state.responses[index] = action.payload;
      }
    },
    deleteResponse: (state, action: PayloadAction<string>) => {
      state.responses = state.responses.filter(response => response.id !== action.payload);
    },
    selectResponse: (state, action: PayloadAction<string>) => {
      state.selectedResponse = state.responses.find(response => response.id === action.payload) || null;
    },
    clearSelectedResponse: (state) => {
      state.selectedResponse = null;
    }
  }
});

export const {
  setLoading,
  setError,
  setResponses,
  addResponse,
  updateResponse,
  deleteResponse,
  selectResponse,
  clearSelectedResponse,
} = cannedResponsesSlice.actions;

// Export the reducer as a named export only
export const cannedResponsesReducer = cannedResponsesSlice.reducer;
